/**
 * Voice mode started from Home: the click makes the chat and moves to it, and
 * the chat page opens voice mode once it is there. What carries across is the
 * AudioContext the click started — one started later, without a click, may
 * not be allowed to play.
 */

const pending = new Map<string, AudioContext>();

export const setPendingVoice = (chatId: string, context: AudioContext): void => {
  pending.set(chatId, context);
};

/** The context for voice mode in this chat, once; null when none waits. */
export function takePendingVoice(chatId: string): AudioContext | null {
  const context = pending.get(chatId) ?? null;
  pending.delete(chatId);
  return context;
}
